/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_CheckingInputs */

const en_directory_submit_badge_checking = /** @type {(inputs: Directory_Submit_Badge_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

const zh_directory_submit_badge_checking = /** @type {(inputs: Directory_Submit_Badge_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查中…`)
};

/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Directory_Submit_Badge_CheckingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_checking = /** @type {((inputs?: Directory_Submit_Badge_CheckingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_CheckingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_checking(inputs)
	return zh_directory_submit_badge_checking(inputs)
});
export { directory_submit_badge_checking as "directory.submit.badge_checking" }